var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step-needs-root" },
    [
      _c(
        "button",
        {
          staticClass: "payment-sandbox-close",
          attrs: { title: "Logout" },
          on: { click: _vm.logoutAndExit },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _c(
        "OnboardingLayout",
        {
          attrs: {
            title: _vm.$t("onboarding.needs.title"),
            subtitle: _vm.$t("onboarding.needs.subtitle"),
            "can-proceed": true,
            "show-progress": false,
            "show-skip-button": false,
            "next-button-label": _vm.$t("onboarding.needs.cta_trial"),
          },
          on: { next: _vm.handleNext },
        },
        [
          _c("div", { staticClass: "onboarding-needs" }, [
            _c("div", { staticClass: "control-group" }, [
              _c("label", { attrs: { for: "pages-value" } }, [
                _vm._v(_vm._s(_vm.$t("onboarding.needs.pages_label"))),
              ]),
              _c("div", { staticClass: "slider-wrapper" }, [
                _c("input", {
                  staticClass: "slider",
                  style: _vm.pagesSliderStyle,
                  attrs: {
                    id: "pages-slider",
                    type: "range",
                    min: _vm.SLIDER_CONFIG.MIN_PERCENT,
                    max: _vm.SLIDER_CONFIG.MAX_PERCENT,
                    step: _vm.SLIDER_CONFIG.STEP,
                  },
                  domProps: { value: _vm.pagesSliderValue },
                  on: {
                    input: function ($event) {
                      return _vm.onPagesSlider($event)
                    },
                  },
                }),
                _c("input", {
                  staticClass: "number-input",
                  attrs: {
                    id: "pages-value",
                    type: _vm.isPagesCustom ? "text" : "number",
                    min: _vm.pagesMin,
                    max: _vm.pagesMax,
                    readonly: _vm.isPagesCustom,
                  },
                  domProps: { value: _vm.pagesDisplayValue },
                  on: {
                    input: function ($event) {
                      return _vm.onPagesInput($event)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "control-group" }, [
              _c("label", { attrs: { for: "users-value" } }, [
                _vm._v(_vm._s(_vm.$t("onboarding.needs.users_label"))),
              ]),
              _c("div", { staticClass: "slider-wrapper" }, [
                _c("input", {
                  staticClass: "slider",
                  style: _vm.usersSliderStyle,
                  attrs: {
                    id: "users-slider",
                    type: "range",
                    min: _vm.SLIDER_CONFIG.MIN_PERCENT,
                    max: _vm.SLIDER_CONFIG.MAX_PERCENT,
                    step: _vm.SLIDER_CONFIG.STEP,
                  },
                  domProps: { value: _vm.usersSliderValue },
                  on: {
                    input: function ($event) {
                      return _vm.onUsersSlider($event)
                    },
                  },
                }),
                _c("input", {
                  staticClass: "number-input",
                  attrs: {
                    id: "users-value",
                    type: _vm.isUsersCustom ? "text" : "number",
                    min: _vm.usersMin,
                    max: _vm.usersMax,
                    readonly: _vm.isUsersCustom,
                  },
                  domProps: { value: _vm.usersDisplayValue },
                  on: {
                    input: function ($event) {
                      return _vm.onUsersInput($event)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "needs-select-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("onboarding.needs.existing_tool_label"))),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeExistingTool,
                      expression: "closeExistingTool",
                    },
                  ],
                  staticClass: "needs-select-wrapper",
                  class: { open: _vm.existingToolOpen },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "needs-select-trigger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.existingToolOpen = !_vm.existingToolOpen
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { class: { placeholder: !_vm.existingTool } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.existingTool ||
                                  _vm.$t("onboarding.needs.select_placeholder")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass:
                          "fa-solid fa-chevron-down needs-select-arrow",
                        class: { rotated: _vm.existingToolOpen },
                      }),
                    ]
                  ),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.existingToolOpen,
                          expression: "existingToolOpen",
                        },
                      ],
                      staticClass: "needs-select-dropdown",
                    },
                    _vm._l(_vm.existingToolOptions, function (option, i) {
                      return _c(
                        "li",
                        {
                          key: "tool-" + i,
                          class: { selected: _vm.existingTool === option },
                          on: {
                            click: function ($event) {
                              return _vm.selectExistingTool(option)
                            },
                          },
                        },
                        [_vm._v(_vm._s(option))]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "needs-select-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("onboarding.needs.referral_label"))),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeReferral,
                      expression: "closeReferral",
                    },
                  ],
                  staticClass: "needs-select-wrapper",
                  class: { open: _vm.referralOpen },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "needs-select-trigger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.referralOpen = !_vm.referralOpen
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { class: { placeholder: !_vm.referralSource } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.referralSource ||
                                  _vm.$t("onboarding.needs.select_placeholder")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass:
                          "fa-solid fa-chevron-down needs-select-arrow",
                        class: { rotated: _vm.referralOpen },
                      }),
                    ]
                  ),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.referralOpen,
                          expression: "referralOpen",
                        },
                      ],
                      staticClass: "needs-select-dropdown",
                    },
                    _vm._l(_vm.referralOptions, function (option, i) {
                      return _c(
                        "li",
                        {
                          key: "ref-" + i,
                          class: { selected: _vm.referralSource === option },
                          on: {
                            click: function ($event) {
                              return _vm.selectReferral(option)
                            },
                          },
                        },
                        [_vm._v(_vm._s(option))]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }